module.exports = __webpack_public_path__ + "static/img/google_paly.1cbb74b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/google_paly.png
// module id = hb/p
// module chunks = 0